import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import { toast } from "sonner";

export const CACHE_TIME = 1000 * 60 * 5; // 5 minutes
export const STALE_TIME = 1000 * 60 * 5; // 5 minutes

const getErrorMessage = (error) => {
  if (!error) return "An error occurred";

  const maybeAxiosMessage =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.response?.data?.detail;

  return maybeAxiosMessage || error.message || "An error occurred";
};

const shouldToastError = (meta) => meta?.toast !== false;

export const queryClient = new QueryClient({
  // queryCache: new QueryCache({
  //   onError: (error, query) => {
  //     if (!shouldToastError(query?.meta)) return;
  //     toast.error(getErrorMessage(error));
  //   },
  // }),
  // mutationCache: new MutationCache({
  //   onError: (error, variables, context, mutation) => {
  //     if (!shouldToastError(mutation?.options?.meta)) return;
  //     toast.error(getErrorMessage(error));
  //   },
  // }),
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME,
      cacheTime: 1000 * 60 * 30,
      refetchOnWindowFocus: false,
      retry: 1,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      retry: 1,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});

export const clearCache = () => {
  queryClient.clear();
  localStorage.clear();
};
